import { initContract } from '@ts-rest/core';
import { User } from '../types/zod/user';
import { z } from 'zod';

const c = initContract();

export const userContract = c.router({
  findAll: {
    method: 'GET',
    path: `/user`,
    responses: { 200: c.type<User[]>() },
  },
  findById: {
    method: 'GET',
    path: `/user/:userId`,
    pathParams: z.object({
      userId: z.string(),
    }),
    responses: { 200: c.type<User>() },
  },
});
